export default {"src":"/_next/static/media/scan.cfeeb8d0.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};